import * as React from 'react';
import { LazyLoad } from '@cian/lazyload-component';
import { declineNumeric } from '../../utils/format_helper';
import { Link } from '../link/link';
import { ETransportType, INewbuildingRecommendations } from '../../types/newbuilding_recommendations';
import { waitForImage } from '../../utils/lazy_load_helper';

const styles = require('./index.css');

interface IProps {
  metro?: INewbuildingRecommendations['underground'];
  url: string;
  priceDisplay: string;
  address?: string;
  thumbnailUrl?: string;
  name: string;
  onClick(): void;
}

export class RecommendedItem extends React.Component<IProps> {
  public renderAddress() {
    const { metro } = this.props;

    if (metro) {
      return (
        <div className={styles['metro']}>
          <div className={styles['metro-name']}>
            <span className={styles['c-line-marker']} style={{ backgroundColor: `#${metro.lineColor}` }} />
            {metro.name}
          </div>
          {metro.time !== null && (
            <div className={styles['metro-time']}>
              {metro.time}
              &nbsp;
              {declineNumeric(metro.time, ['минута', 'минуты', 'минут'])}
              &nbsp;
              {metro.transportType === ETransportType.Walk ? 'пешком' : 'на транспорте'}
            </div>
          )}
        </div>
      );
    } else {
      return <div className={styles['address']}>{this.props.address}</div>;
    }
  }

  public render() {
    const { thumbnailUrl = '' } = this.props;

    return (
      <Link href={this.props.url} target="_blank" className={`${styles['link']} cg-col-8`} onClick={this.props.onClick}>
        <div className={styles['info']}>
          <div className={styles['gk-name']}>{this.props.name}</div>
          <div className={styles['price']}>{this.props.priceDisplay}</div>
          {this.renderAddress()}
        </div>
        <LazyLoad
          onLoad={() => waitForImage(thumbnailUrl)}
          renderEmpty={() => <div className={styles['photo-wrap']} />}
          renderLoading={() => <div className={styles['photo-wrap']} />}
          renderLoaded={(imageUrl: string) => (
            <div className={styles['photo-wrap']} style={{ backgroundImage: `url(${imageUrl})` }} />
          )}
          renderError={() => <div className={styles['photo-wrap']} />}
        />
      </Link>
    );
  }
}
